import { parse as partialParse } from "partial-json";

/**
 * Attempts to parse potentially incomplete JSON during streaming.
 * Always returns a valid object, even if the JSON is incomplete.
 *
 * @param partialJson The partial JSON string from streaming
 * @returns Parsed object or empty object if parsing fails
 */
export function parseStreamingJson<T = any>(
	partialJson: string | undefined,
	onWarning?: (code: string, message: string) => void,
): T {
	if (!partialJson || partialJson.trim() === "") {
		return {} as T;
	}

	// Try standard parsing first (fastest for complete JSON)
	try {
		return JSON.parse(partialJson) as T;
	} catch {
		// Try partial-json for incomplete JSON
		try {
			const result = partialParse(partialJson);
			return (result ?? {}) as T;
		} catch {
			// Both JSON.parse and partial-json failed — input is unparseable garbage
			onWarning?.(
				"json_parse_total_failure",
				`Both JSON.parse and partial-json failed on: ${partialJson.slice(0, 200)}`,
			);
			return {} as T;
		}
	}
}
